import { render, staticRenderFns } from "./I18nGetsum.vue?vue&type=template&id=10f2a2ed&"
import script from "./I18nGetsum.vue?vue&type=script&lang=js&"
export * from "./I18nGetsum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports